import { ListRole } from '~/features/common/Taxipark/Roles/ListRole'
import { Container } from '~/shared/ui/Layout'

export const ListRolePage = () => {
  return (
    <Container>
      <ListRole />
    </Container>
  )
}
